import { useState } from 'react';
import styles from './HobbiesBackground.module.css';

export default function HobbiesBackground() {
  const [animate, setAnimate] = useState(false);

  const clickHandler = () => {
    setAnimate(true);
    setTimeout(() => setAnimate(false), 600);
  };

  return (
    <>
      <div className={styles.brainWrapper}>
        <svg
          onClick={clickHandler}
          className={animate ? `${styles.brain} ${styles.animate}` : styles.brain}
          version="1.1"
          id="brain"
          x="0px"
          y="0px"
          viewBox="-246.557 0 2060.378 1150.5"
          enableBackground="new -246.557 0 2060.378 1150.5"
        >
          <g id="Yellow">
            <path fill="#FFF275" d="M0,757.986c0-415.869,337.129-753,753-753c415.87,0,753,337.13,753,753"/>
          </g>
          <path fill="#6AC5AA" d="M1610.405,1060.334c0,6.305-4.554,11.416-10.169,11.416H-80.596c-5.616,0-10.169-5.111-10.169-11.416
            V772.553c0-6.305,4.553-11.416,10.169-11.416h1680.833c5.615,0,10.169,5.111,10.169,11.416v143.891V1060.334z"/>
          <g id="Layer_1_1_">
            <g id="Background">
              <rect x="4.808" y="1.479" display="none" fill="#FEF0F5" width="1506" height="1146.722"/>
              <rect x="2.958" y="729.692" display="none" opacity="0.89" fill="#4C2F41" enableBackground="new    " width="1506" height="416.618"/>
              <rect x="2.958" y="769.798" display="none" fill="#FFD4E7" width="1506" height="380.291"/>
              <g>
                <g>
                  <path fill="#282828" d="M303.172,870.501V760.979c0-1.72,1.395-3.109,3.115-3.109h210.275c1.721,0,3.11,1.396,3.11,3.109v109.522
                    c0,1.721-1.394,3.114-3.11,3.114H306.289C304.567,873.615,303.172,872.221,303.172,870.501z"/>
                  <g>
                    <g>
                      <rect x="335.091" y="748.423" fill="#E88918" width="25.413" height="9.441"/>
                      <rect x="462.347" y="748.423" fill="#E88918" width="25.413" height="9.441"/>
                    </g>
                    <path fill="#FFA733" d="M477.567,748.423h-5.031v-15.719c0-3.482-2.833-6.315-6.315-6.315H356.629
                      c-3.479,0-6.316,2.833-6.316,6.315v15.719h-5.027v-15.719c0-6.257,5.091-11.349,11.348-11.349h109.592
                      c6.258,0,11.351,5.092,11.351,11.349v15.719H477.567z"/>
                  </g>
                  <g>
                    <circle opacity="0.5" fill="#FFA733" enableBackground="new    " cx="474.238" cy="820.771" r="35.607"/>
                    <path fill="#FFA733" d="M443.663,820.771c0-16.859,13.716-30.576,30.576-30.576c16.856,0,30.576,13.717,30.576,30.576
                      c0,16.854-13.72,30.57-30.576,30.57C457.377,851.347,443.663,837.63,443.663,820.771z"/>
                  </g>
                  <g>
                    <circle opacity="0.5" fill="#FFA733" enableBackground="new    " cx="346.771" cy="820.771" r="35.607"/>
                    <path fill="#FFA733" d="M316.195,820.771c0-16.859,13.716-30.576,30.576-30.576c16.855,0,30.572,13.717,30.572,30.576
                      c0,16.854-13.716,30.57-30.572,30.57C329.91,851.346,316.195,837.63,316.195,820.771z"/>
                  </g>
                  <g>
                    <rect x="385.333" y="748.423" fill="#F9F1E8" width="13.596" height="9.441"/>
                    <rect x="404.626" y="748.423" fill="#F9F1E8" width="13.596" height="9.441"/>
                    <rect x="423.922" y="748.423" fill="#F9F1E8" width="13.596" height="9.441"/>
                  </g>
                  <rect x="388.795" y="805.229" fill="#FFA733" width="45.258" height="17.607"/>
                  <g>
                    <g>
                      <circle opacity="0.5" fill="#FFA733" enableBackground="new    " cx="398.731" cy="850.796" r="10.006"/>
                    </g>
                    <g>
                      <circle opacity="0.5" fill="#FFA733" enableBackground="new    " cx="424.119" cy="850.796" r="10.006"/>
                    </g>
                  </g>
                  <line fill="none" stroke="#FFA733" strokeMiterlimit="10" x1="303.172" y1="777.251" x2="519.402" y2="777.251"/>
                  <g>
                    <rect x="388.795" y="826.842" fill="#FFA733" width="45.258" height="7.776"/>
                    <g>
                      <line fill="none" stroke="#333333" strokeWidth="1.2578" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="396.414" y1="826.842" x2="396.414" y2="834.619"/>
                      <line fill="none" stroke="#333333" strokeWidth="1.2578" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="403.918" y1="826.842" x2="403.918" y2="834.619"/>
                      <line fill="none" stroke="#333333" strokeWidth="1.2578" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="411.425" y1="826.842" x2="411.425" y2="834.619"/>
                      <line fill="none" stroke="#333333" strokeWidth="1.2578" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="418.932" y1="826.842" x2="418.932" y2="834.619"/>
                      <line fill="none" stroke="#333333" strokeWidth="1.2578" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="426.438" y1="826.842" x2="426.438" y2="834.619"/>
                    </g>
                  </g>
                  <rect x="314.373" y="764.466" fill="none" stroke="#FFA733" strokeMiterlimit="10" width="35.819" height="7.209"/>
                  <circle fill="none" stroke="#FFA733" strokeMiterlimit="10" cx="363.703" cy="768.071" r="3.604"/>
                  <circle fill="none" stroke="#FFA733" strokeMiterlimit="10" cx="377.349" cy="768.071" r="3.604"/>
                  <circle fill="none" stroke="#FFA733" strokeMiterlimit="10" cx="390.994" cy="768.071" r="3.604"/>
                </g>
                <g>
                  <g>
                    <g>
                      <path fill="#282828" d="M493.415,948.257c0-16.319-14.859-29.557-33.189-29.557c-18.329,0-33.188,13.232-33.188,29.557
                        c0,6.729,2.525,12.911,6.778,17.869c3.769,4.394,2.393,11.164-2.688,13.938l0,0c-2.522,1.375-4.093,4.021-4.093,6.894v65.896
                        c0,3.687,2.982,6.673,6.671,6.673h53.034c3.686,0,6.672-2.986,6.672-6.673v-65.899c0-2.873-1.57-5.52-4.097-6.895l0,0
                        c-5.075-2.771-6.452-9.543-2.688-13.937C490.886,961.169,493.415,954.981,493.415,948.257z"/>
                      <path opacity="0.2" fill="#282828" enableBackground="new    " d="M493.415,948.257c0-16.319-14.859-29.557-33.189-29.557
                        c-18.329,0-33.188,13.232-33.188,29.557c0,6.729,2.525,12.911,6.778,17.869c3.769,4.394,2.393,11.164-2.688,13.938l0,0
                        c-2.522,1.375-4.093,4.021-4.093,6.894v65.896c0,3.687,2.982,6.673,6.671,6.673h53.034c3.686,0,6.672-2.986,6.672-6.673
                        v-65.899c0-2.873-1.57-5.52-4.097-6.895l0,0c-5.075-2.771-6.452-9.543-2.688-13.937
                        C490.886,961.169,493.415,954.981,493.415,948.257z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path fill="#FF7A97" d="M474.103,924.387h-27.757c-3.127,0-5.686-2.563-5.686-5.688l0,0c0-3.128,2.559-5.688,5.686-5.688
                        h27.757c3.128,0,5.688,2.561,5.688,5.688l0,0C479.79,921.828,477.231,924.387,474.103,924.387z"/>
                      <path fill="#FF7A97" d="M467.802,918.701H452.65c-0.791,0-1.438-0.646-1.438-1.438v-13.895c0-0.791,0.646-1.438,1.438-1.438
                        h15.151c0.791,0,1.438,0.646,1.438,1.438v13.895C469.239,918.054,468.593,918.701,467.802,918.701z"/>
                    </g>
                  </g>
                </g>
                <path fill="none" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                  M440.217,932.723c-1.71,1.807-4.247,5.079-5.105,9.702c-1.469,7.896,2.577,16.396,10.217,21.957"/>
                <g>
                  <g>
                    <polygon fill="#1A2E35" points="1393.589,592.671 1293.193,940.527 1311.646,940.527 1412.044,592.671"/>
                    <polygon fill="#1A2E35" points="1087.443,940.527 1105.896,940.527 1206.293,592.671 1187.84,592.671"/>
                  </g>
                  <g>
                    <g>
                      <g>
                        <g>
                          <g>
                            <path fill="#666666" d="M1070.951,910.739c-40.834,0-73.938-33.104-73.938-73.938s33.104-73.936,73.938-73.936h11.257
                              v147.868L1070.951,910.739L1070.951,910.739z"/>
                          </g>
                          <circle fill="#282828" cx="1082.203" cy="836.804" r="73.935"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <path fill="#666666" d="M1090.343,910.739c-40.833,0-73.938-33.104-73.938-73.938s33.104-73.936,73.938-73.936h11.255
                              v147.868L1090.343,910.739L1090.343,910.739z"/>
                          </g>
                          <circle fill="#282828" cx="1101.598" cy="836.804" r="73.936"/>
                        </g>
                      </g>
                      <path fill="#1A2E35" d="M1113.242,854.075h126.365c1.522,0,2.762-1.236,2.762-2.767v-29.021c0-1.524-1.233-2.766-2.762-2.766
                        h-126.365c-9.535,0-17.271,7.731-17.271,17.271l0,0C1095.97,846.342,1103.703,854.075,1113.242,854.075z"/>
                      <g>
                        <g>
                          <path fill="#666666" d="M1261.244,910.739c-40.834,0-73.938-33.104-73.938-73.938s33.104-73.936,73.938-73.936h11.253
                            v147.868L1261.244,910.739L1261.244,910.739z"/>
                        </g>
                        <circle fill="#282828" cx="1272.496" cy="836.804" r="73.936"/>
                      </g>
                      <g>
                        <g>
                          <path fill="#686868" d="M1280.604,910.739c-40.832,0-73.936-33.104-73.936-73.938s33.104-73.936,73.936-73.936h11.255
                            v147.868L1280.604,910.739L1280.604,910.739z"/>
                        </g>
                        <circle fill="#282828" cx="1291.859" cy="836.804" r="73.935"/>
                      </g>
                      <g>
                        <g>
                          <path opacity="0.2" enableBackground="new    " d="M1286.692,875.297c-21.262,0-38.494-17.232-38.494-38.492
                            c0-21.261,17.232-38.494,38.494-38.494h10.333v76.986H1286.692z"/>
                        </g>
                        <circle fill="#282828" cx="1297.025" cy="836.804" r="38.494"/>
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <g>
                          <g>
                            <path fill="#666666" d="M1138.549,744.563c-40.833,0-73.938-33.104-73.938-73.938c0-40.834,33.104-73.938,73.938-73.938
                              h11.254v147.871L1138.549,744.563L1138.549,744.563z"/>
                          </g>
                          <circle fill="#282828" cx="1149.802" cy="670.626" r="73.935"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <path fill="#666666" d="M1157.942,744.563c-40.834,0-73.938-33.104-73.938-73.938c0-40.834,33.104-73.938,73.938-73.938
                              h11.253v147.871L1157.942,744.563L1157.942,744.563z"/>
                          </g>
                          <circle fill="#282828" cx="1169.195" cy="670.626" r="73.936"/>
                        </g>
                      </g>
                      <path fill="#1A2E35" d="M1180.84,687.896h126.365c1.521,0,2.762-1.231,2.762-2.763v-29.021c0-1.523-1.234-2.767-2.762-2.767
                        H1180.84c-9.538,0-17.271,7.733-17.271,17.271l0,0C1163.568,680.164,1171.302,687.896,1180.84,687.896z"/>
                      <g>
                        <g>
                          <path fill="#666666" d="M1328.842,744.563c-40.834,0-73.938-33.104-73.938-73.938c0-40.834,33.104-73.938,73.938-73.938
                            h11.253v147.871L1328.842,744.563L1328.842,744.563z"/>
                        </g>
                        <circle fill="#282828" cx="1340.095" cy="670.626" r="73.936"/>
                      </g>
                      <g>
                        <g>
                          <path fill="#686868" d="M1348.203,744.563c-40.832,0-73.938-33.104-73.938-73.938c0-40.834,33.104-73.938,73.938-73.938
                            h11.254v147.871L1348.203,744.563L1348.203,744.563z"/>
                        </g>
                        <circle fill="#282828" cx="1359.457" cy="670.626" r="73.935"/>
                      </g>
                      <g>
                        <g>
                          <path opacity="0.2" enableBackground="new    " d="M1354.291,709.119c-21.264,0-38.494-17.234-38.494-38.493
                            c0-21.26,17.23-38.494,38.494-38.494h10.333v76.987H1354.291z"/>
                        </g>
                        <circle fill="#282828" cx="1364.623" cy="670.626" r="38.494"/>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Legs">
            <g id="Left_Leg">
              <path id="upper_leg" fill="#663300" d="M720.742,833.993h3c3.021,0,5.5-2.479,5.5-5.5V772.1c0-3.021-2.479-5.5-5.5-5.5h-3
                c-3.024,0-5.5,2.479-5.5,5.5v56.395C715.242,831.519,717.716,833.993,720.742,833.993z"/>
              <path id="lower_leg" fill="#663300" d="M721.242,886.943h2c3.301,0,6-2.699,6-6v-56.21c0-3.305-2.699-6-6-6h-2
                c-3.3,0-6,2.695-6,6v56.21C715.242,884.244,717.941,886.943,721.242,886.943z"/>
              <path id="feet" fill="#663300" d="M729.47,887.017c-15.302-0.134-30.604-0.27-45.905-0.397c-0.464-1.553-1.396-5.481,0.354-9.729
                c0,0,1.455-3.54,4.738-6.026c9.804-7.439,34.229-1.431,39.71,11.766C729.125,884.462,729.374,886.084,729.47,887.017z"/>
            </g>
            <g id="Right_Leg">
              <path id="upper_leg_1_" fill="#663300" d="M794.805,834.003h-3c-3.021,0-5.5-2.476-5.5-5.5v-56.391c0-3.023,2.479-5.5,5.5-5.5h3
                c3.024,0,5.5,2.477,5.5,5.5v56.391C800.305,831.527,797.83,834.003,794.805,834.003z"/>
              <path id="lower_leg_1_" fill="#663300" d="M794.305,886.953h-2c-3.3,0-6-2.7-6-6v-56.21c0-3.3,2.7-6,6-6h2c3.306,0,6,2.7,6,6
                v56.21C800.305,884.253,797.605,886.953,794.305,886.953z"/>
              <path id="feet_1_" fill="#663300" d="M786.077,887.026c15.303-0.14,30.604-0.271,45.905-0.403
                c0.463-1.552,1.396-5.481-0.354-9.725c0,0-1.455-3.54-4.734-6.031c-9.808-7.438-34.23-1.426-39.709,11.766
                C786.421,884.472,786.174,886.094,786.077,887.026z"/>
            </g>
          </g>
          <g id="Arms">
            <g id="Left">
              <path id="ArmLeft" fill="#663300" d="M585.49,508.909c2.058,5.438,6.745,8.896,10.469,7.729l1.64-0.514
                c3.729-1.167,5.076-6.521,3.021-11.961l-32.91-86.983c-2.057-5.438-6.745-8.896-10.469-7.729l-1.645,0.514
                c-3.725,1.167-5.071,6.522-3.019,11.961L585.49,508.909z"/>
              <path id="HandLeft" fill="#663300" d="M574.553,313.592c-1.374,7.103,5.82,14.191,16.068,15.833
                c10.248,1.642,19.669-2.784,21.043-9.886s-5.819-14.191-16.067-15.833S575.926,306.49,574.553,313.592z"/>
              <path id="ForeArmLeft" fill="#663300" d="M552.339,411.512c-2.011,5.314-0.622,10.569,3.104,11.736l1.64,0.515
                c3.725,1.167,8.375-2.191,10.385-7.51l36.979-97.74c2.011-5.315,0.622-10.57-3.104-11.737l-1.64-0.514
                c-3.729-1.167-8.375,2.195-10.386,7.51L552.339,411.512z"/>
            </g>
            <g id="Right">
              <path id="ArmRight" fill="#663300" d="M937.317,509.801c-2.063,5.438-6.745,8.901-10.475,7.734l-1.641-0.514
                c-3.726-1.172-5.076-6.522-3.021-11.966l32.908-86.979c2.063-5.438,6.745-8.901,10.475-7.733l1.64,0.519
                c3.727,1.167,5.076,6.521,3.021,11.961L937.317,509.801z"/>
              <path id="HandRight" fill="#663300" d="M948.255,314.485c1.374,7.102-5.82,14.19-16.067,15.833
                c-10.244,1.643-19.671-2.784-21.045-9.886c-1.373-7.102,5.82-14.191,16.068-15.833
                C937.458,302.958,946.881,307.382,948.255,314.485z"/>
              <path id="ForeArmRight" fill="#663300" d="M970.468,412.404c2.017,5.313,0.622,10.564-3.104,11.731l-1.645,0.52
                c-3.727,1.167-8.375-2.196-10.386-7.515l-36.979-97.74c-2.017-5.315-0.622-10.569,3.104-11.737l1.645-0.514
                c3.726-1.167,8.375,2.195,10.386,7.51L970.468,412.404z"/>
            </g>
          </g>
          <g id="Body">
            <g id="Body_1_">
              <path fill="#FF96A5" d="M976.998,604.567c0-23.032-15.039-42.654-35.385-51.188c7.961-7.678,13.271-18.766,13.271-30.71
                c0-23.886-20.349-43.507-45.118-43.507c-1.771,0-3.538,0-4.422,0c2.651-5.971,4.422-12.796,4.422-19.621
                c0-23.885-20.346-43.506-45.111-43.506c-7.967,0-15.039,1.707-21.23,5.118c-6.189-17.063-23.001-31.563-42.465-31.563
                c-24.771,0-44.229,22.184-45.115,39.24l0,0v298.575h0.887l0,0c0,30.71,25.653,54.597,57.504,54.597
                c28.311,0,51.311-19.62,56.614-45.215c5.312,1.707,11.5,2.561,17.691,2.561c31.848,0,57.501-24.732,57.501-55.443
                c0-9.389-2.653-18.771-7.075-27.304C960.19,649.78,976.998,629.307,976.998,604.567z"/>
              <path fill="#FF96A5" d="M535.604,604.567c0-23.032,15.038-42.654,35.39-51.188c-7.961-7.678-13.271-18.766-13.271-30.71
                c0-23.886,20.352-43.507,45.117-43.507c1.771,0,3.539,0,4.423,0c-2.65-5.971-4.423-12.796-4.423-19.621
                c0-23.885,20.347-43.506,45.117-43.506c7.962,0,15.039,1.707,21.229,5.118c6.193-17.063,23.001-31.563,42.467-31.563
                c24.771,0,44.229,22.184,45.112,39.24l0,0v298.575h-0.884l0,0c0,30.71-25.654,54.597-57.502,54.597
                c-28.309,0-51.31-19.62-56.617-45.215c-5.307,1.707-11.5,2.561-17.688,2.561c-31.852,0-57.501-24.732-57.501-55.443
                c0-9.389,2.649-18.771,7.075-27.304C552.411,649.78,535.604,629.307,535.604,604.567z"/>
            </g>
            <g id="Body_Details">
              <path fill="none" stroke="#FF7A97" strokeWidth="9.0846" strokeMiterlimit="10" d="M535.604,604.567
                c0-23.032,15.038-42.654,35.39-51.188c-7.961-7.678-13.271-18.766-13.271-30.71c0-23.886,20.352-43.507,45.117-43.507
                c1.771,0,3.539,0,4.423,0c-2.65-5.971-4.423-12.796-4.423-19.621c0-23.885,20.347-43.506,45.117-43.506
                c7.962,0,15.039,1.707,21.229,5.118c6.193-17.063,23.001-31.563,42.467-31.563c24.771,0,44.229,22.184,45.112,39.24v298.575
                h-0.884c0,30.71-25.654,54.597-57.502,54.597c-28.309,0-51.31-19.62-56.617-45.215c-5.307,1.707-11.5,2.561-17.688,2.561
                c-31.852,0-57.501-24.732-57.501-55.443c0-9.389,2.649-18.771,7.075-27.304C552.411,649.78,535.604,629.307,535.604,604.567z"/>
              <path fill="none" stroke="#FF7A97" strokeWidth="9.0846" strokeMiterlimit="10" d="M976.998,604.567
                c0-23.032-15.039-42.654-35.385-51.188c7.961-7.678,13.271-18.766,13.271-30.71c0-23.886-20.349-43.507-45.118-43.507
                c-1.771,0-3.538,0-4.422,0c2.651-5.971,4.422-12.796,4.422-19.621c0-23.885-20.346-43.506-45.111-43.506
                c-7.967,0-15.039,1.707-21.23,5.118c-6.189-17.063-23.001-31.563-42.465-31.563c-24.771,0-44.229,22.184-45.115,39.24l0,0
                v298.575h0.887l0,0c0,30.71,25.653,54.597,57.504,54.597c28.311,0,51.311-19.62,56.614-45.215
                c5.312,1.707,11.5,2.561,17.691,2.561c31.848,0,57.501-24.732,57.501-55.443c0-9.389-2.653-18.771-7.075-27.304
                C960.19,649.78,976.998,629.307,976.998,604.567z"/>
              <rect x="746.861" y="450.302" fill="#FF96A5" width="17.951" height="277.106"/>
            </g>
          </g>
          <g id="Band">
            <g>
              <path fill="none" stroke="#18A304" strokeWidth="27.4831" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                M599.819,474.399c47.182-5.81,100.184-9.688,158.082-9.662c57.505,0.021,110.172,3.89,157.092,9.662"/>
              <path fill="none" stroke="#282828" strokeWidth="9.4597" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                M591.709,474.832c49.123-6.004,104.053-10.015,163.896-10.093c61.255-0.08,117.395,3.973,167.466,10.093"/>
            </g>
          </g>
          <g id="Barbell">
            <path fill="#1A2E35" d="M1105.509,321.576H408.166c-3.645,0-6.627-5.541-6.627-12.313l0,0c0-6.772,2.979-12.313,6.627-12.313
              h697.343c3.646,0,6.627,5.541,6.627,12.313l0,0C1112.136,316.035,1109.153,321.576,1105.509,321.576z"/>
            <g>
              <path fill="#292C39" d="M1051.455,241.54c0-3.855,3.154-7.01,7.011-7.01h23.366c3.854,0,7.01,3.154,7.01,7.01v130.848
                c0,3.855-3.154,7.01-7.01,7.01h-23.366c-3.854,0-7.011-3.154-7.011-7.01V241.54z"/>
            </g>
            <g>
              <path fill="#2B2E3B" d="M1014.849,218.172c0-3.855,3.154-7.009,7.015-7.009h24.146c3.854,0,7.013,3.154,7.013,7.009v182.254
                c0,3.855-3.152,7.01-7.013,7.01h-24.146c-3.854,0-7.015-3.149-7.015-7.01V218.172L1014.849,218.172z"/>
            </g>
            <g>
              <path fill="#292C39" d="M461.786,244.93c0-3.855-3.154-7.01-7.01-7.01H431.41c-3.855,0-7.01,3.154-7.01,7.01v130.848
                c0,3.855,3.149,7.01,7.01,7.01h23.366c3.854,0,7.01-3.154,7.01-7.01V244.93z"/>
            </g>
            <g>
              <path fill="#2B2E3B" d="M498.392,221.565c0-3.855-3.149-7.01-7.01-7.01h-24.144c-3.855,0-7.015,3.154-7.015,7.01v182.253
                c0,3.854,3.155,7.01,7.015,7.01h24.145c3.855,0,7.01-3.154,7.01-7.01L498.392,221.565L498.392,221.565z"/>
            </g>
          </g>
          <g id="Happy">
            <g>
              <g>
                <circle fill="#663300" cx="697.005" cy="554.332" r="24.59"/>
                <circle fill="#FFFFFF" cx="703.963" cy="546.626" r="9.291"/>
                <circle fill="#FFFFFF" cx="689.226" cy="566.16" r="4.904"/>
                <ellipse fill="#FA4675" cx="697.005" cy="588.843" rx="11.859" ry="5.534"/>
              </g>
              <g>
                <circle fill="#663300" cx="808.569" cy="553.528" r="24.59"/>
                <circle fill="#FFFFFF" cx="815.527" cy="545.821" r="9.291"/>
                <circle fill="#FFFFFF" cx="800.789" cy="565.356" r="4.904"/>
                <ellipse fill="#FA4675" cx="808.569" cy="588.041" rx="11.855" ry="5.533"/>
              </g>
            </g>
            <g>
              <path fill="#663300" d="M704.497,622.197c5.436-7.188,22.315,5.977,54.842,5.615c31.133-0.351,47.125-12.75,51.993-6.173
                c4.969,6.719-6.466,26.656-22.104,37.246c-18.667,12.646-46.431,14.058-65.607-0.062
                C709.524,648.461,699.259,629.118,704.497,622.197z"/>
              <path fill="#FA4675" d="M710.847,645.729c0.691-0.466,16.204-10.519,32.912-2.492c15.604,7.485,18.232,24.013,18.419,25.315
                c-4.783,0.629-16.433,1.518-29.352-4.381C720.451,658.528,713.591,649.715,710.847,645.729z"/>
            </g>
          </g>
          <g id="Sad" opacity="0">
            <path fill="none" stroke="#663300" strokeWidth="7.7387" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
              M725.382,637.912c8.396-1.896,19.271-3.563,31.993-3.555c12.675,0.005,23.513,1.667,31.889,3.555"/>
            <g>
              <path fill="none" stroke="#663300" strokeWidth="4.7591" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                M685.158,542.815c3.25,0.831,7.063,2.135,11.103,4.229c5.086,2.649,16.876,13.838,18.441,15.996
                c-2.605-1.396-10.729-5.301-20.511-3.012c-3.896,0.909-6.933,2.542-9.033,3.946"/>
              <path fill="none" stroke="#663300" strokeWidth="4.7591" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                M820.717,542.669c-3.25,0.831-7.063,2.135-11.104,4.233c-9.389,4.881-15.245,11.604-18.441,15.996
                c2.605-1.396,10.729-5.306,20.512-3.017c3.896,0.911,6.932,2.542,9.033,3.951"/>
              <path fill="#A2FDFF" d="M831.283,586.554l9.563,21.769c3.372,3.264,8.493,3.563,11.829,1.041
                c3.896-2.947,4.63-9.195,0.979-13.387C846.199,592.835,838.741,589.694,831.283,586.554z"/>
              <path fill="#A2FDFF" d="M674.422,592.825l-21.764,9.563c-3.271,3.373-3.568,8.494-1.041,11.83
                c2.945,3.895,9.189,4.629,13.383,0.979C668.141,607.74,671.282,600.282,674.422,592.825z"/>
              <path fill="#A2FDFF" d="M688.831,489.294l-11.164,20.989c-0.474,4.669,2.46,8.878,6.51,9.932
                c4.729,1.229,10.086-2.06,11.114-7.52C693.138,504.896,690.984,497.094,688.831,489.294z"/>
              <ellipse fill="#FA4675" cx="807.121" cy="588.325" rx="14.109" ry="6.583"/>
              <ellipse fill="#FA4675" cx="699.467" cy="588.325" rx="14.11" ry="6.583"/>
            </g>
          </g>
          <path fill="#06AC5A" stroke="#000000" strokeMiterlimit="10" d="M-246.557,932.723"/>
          <ellipse fill="#6AC5AA" cx="-90.765" cy="916.409" rx="148.786" ry="155.341"/>
          <circle fill="#6AC5AA" cx="1610.405" cy="916.443" r="155.307"/>
        </svg>
      </div>
    </>
  );
}
